var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      attrs: { id: "login" },
      on: {
        keyup: function($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          ) {
            return null
          }
          return _vm.submit()
        }
      }
    },
    [
      _vm.$device.isDesktop ? _c("div", [_vm._v("Desktop")]) : _vm._e(),
      _vm._v(" "),
      _vm.$root.app.platform == "desktop"
        ? _c("div", { staticClass: "login-intro" }, [
            _vm._v("\n        Inloggen bij My Dubline            \n    ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.error
        ? _c("div", {
            staticClass: "error",
            domProps: { innerHTML: _vm._s(_vm.error) }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "form-group",
          class: { "form-group--error": _vm.$v.email.$error }
        },
        [
          _c("label", { staticClass: "form__label" }, [_vm._v("E-mail")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.email,
                expression: "email"
              }
            ],
            staticClass: "form__input",
            attrs: { type: "email" },
            domProps: { value: _vm.email },
            on: {
              input: [
                function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.email = $event.target.value
                },
                function($event) {
                  return _vm.$v.email.$touch()
                }
              ]
            }
          })
        ]
      ),
      _vm._v(" "),
      !_vm.$v.email.email
        ? _c("span", { staticClass: "form-group__message" }, [
            _vm._v("Ongeldige e-mail")
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.$v.email.required
        ? _c("span", { staticClass: "form-group__message" }, [
            _vm._v("Veld is verplicht")
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.$v.email.minLength
        ? _c("span", { staticClass: "form-group__message" }, [
            _vm._v(
              "E-mail moet minimaal " +
                _vm._s(_vm.$v.email.$params.minLength.min) +
                " karakters bevatten."
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "form-group",
          class: { "form-group--error": _vm.$v.password.$error }
        },
        [
          _c("label", { staticClass: "form__label" }, [_vm._v("Wachtwoord")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.password,
                expression: "password"
              }
            ],
            staticClass: "form__input",
            attrs: { type: "password" },
            domProps: { value: _vm.password },
            on: {
              input: [
                function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.password = $event.target.value
                },
                function($event) {
                  return _vm.$v.password.$touch()
                }
              ]
            }
          })
        ]
      ),
      _vm._v(" "),
      !_vm.$v.password.required
        ? _c("span", { staticClass: "form-group__message" }, [
            _vm._v("Veld is verplicht")
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.$v.password.minLength
        ? _c("span", { staticClass: "form-group__message" }, [
            _vm._v(
              "Wachtwoord moet minimaal " +
                _vm._s(_vm.$v.password.$params.minLength.min) +
                " karakters bevatten."
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("input", {
          staticClass: "button dub-button dub-button-space",
          attrs: { type: "submit", value: "Login" },
          on: {
            click: function($event) {
              return _vm.submit()
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("router-link", { attrs: { to: "/forgot-password" } }, [
        _vm._v("\n        Wachtwoord vergeten?\n    ")
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6bab3132", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6bab3132","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/Login.vue
// module id = null
// module chunks = 